<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        to: {
            default() {
                return this.$parent.messages
            }
        }
    },
})
</script>

<template>
    <div>
        <b-alert show v-for="(messageObj, i) in to" :key="i" :variant="messageObj.variant">{{ messageObj.text }}</b-alert>
    </div>
</template>